<div style="float: right;">
    <mat-icon style="cursor: pointer;" (click)="closeModal()">close</mat-icon>
</div>
<div [formGroup]="request_form" style="padding: 0 2em 2em 2em; display: flex; flex-direction: column; width: 100%;">
    <div style="display: flex;flex-direction: row; gap: 1em;">
        <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>File Type</mat-label>
            <mat-select formControlName="fileType">
                <mat-option *ngFor="let item of fileType"
                [value]="item">{{item}}</mat-option>
            </mat-select>
            <mat-error *ngIf=" request_form.controls['fileType'].hasError('required') && request_form.controls['fileType'].touched">
                Required
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Loan Amount</mat-label>   
            <input matInput type="number" formControlName="requestedAmount">     
            <mat-error *ngIf=" request_form.controls['requestedAmount'].hasError('required') && request_form.controls['requestedAmount'].touched">
                Required
            </mat-error>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Requested Reason</mat-label>   
            <textarea matInput formControlName="requestedReason" rows="1"></textarea>   
            <mat-error *ngIf="request_form.controls['requestedReason'].hasError('required') && request_form.controls['requestedReason'].touched">
                Required
            </mat-error>     
        </mat-form-field>
    </div>
    <button mat-raised-button color="primary" [disabled]="request_form.invalid" (click)="requestLegalWaiveOff()">Request</button>
</div>
